module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Spam-6187af90c80846bd942c36e077c5f813.svg";